export const SIDEBAR_MENU_TEST_IDS = {
  mainMenuItem: 'sidebar__menu_main-menu-item_collapsible',
  goToModuleButton: 'sidebar__menu_main-menu_go-to-module-button',
  sidebarMenu: 'sidebar__menu_main-menu',
} as const;
export default SIDEBAR_MENU_TEST_IDS;
export const SIDEBAR_STRIPE_TEST_IDS = {
  stripMenu: 'sidebar-stripe__menu',
};
